/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';
import { enquireScreen } from 'enquire-js';

// import Nav1 from './Nav1';
import Banner from './Banner';
// import Content5 from './Content5';
import Solution from './Solution';
import Scale from './Scale';
import Partner from './Partner';
import OutputPower from './Output_Power';
import Footer from './Footer';
// import Feature4 from './Feature4';
// import BannerSolution from './banner_solution';
import {
  BannerDataSource,
  SolutionDataSource,
  ScaleDataSource,
  PartnerDataSource,
  FooterDataSource,
  OutputPowerDataSource,
} from './data.source';
import './less/antMotionStyle.less';

let isMobile;
enquireScreen((b) => {
  isMobile = b;
});

const { location } = window;

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile,
      show: !location.port, // 如果不是 dva 2.0 请删除
    };
  }

  componentDidMount() {
    // 适配手机屏幕;
    enquireScreen((b) => {
      this.setState({ isMobile: !!b });
    });
    // dva 2.0 样式在组件渲染之后动态加载，导致滚动组件不生效；线上不影响；
    /* 如果不是 dva 2.0 请删除 start */
    if (location.port) {
      // 样式 build 时间在 200-300ms 之间;
      setTimeout(() => {
        this.setState({
          show: true,
        });
      }, 500);
    }
    /* 如果不是 dva 2.0 请删除 end */
  }

  render() {
    const children = [
      // <Nav1
      //   id="Nav1_0"
      //   key="Nav1_0"
      //   dataSource={Nav10DataSource}
      //   isMobile={this.state.isMobile}
      // />,
      <Banner
        id="Banner"
        key="Banner"
        dataSource={BannerDataSource}
        isMobile={this.state.isMobile}
      />,
      <Solution
        id="Solution"
        key="Solution"
        dataSource={SolutionDataSource}
        isMobile={this.state.isMobile}
      />,
      <OutputPower
        id="Content0_3"
        key="Content0_3"
        // 复用Content0模板，但自定义Data
        dataSource={OutputPowerDataSource}
        isMobile={this.state.isMobile}
      />,


      <Scale
        id="Scale"
        key="Scale"
        // 复用Content0模板，但自定义Data
        dataSource={ScaleDataSource}
        isMobile={this.state.isMobile}
      />,
      /*
      <BannerSolution
        id="Banner2_0"
        key="Banner2_0"
        dataSource={Banner20DataSource}
        isMobile={this.state.isMobile}
      />,
      */
      <Partner
        id="Partner"
        key="Partner"
        // 复用Content0模板，但自定义Data
        dataSource={PartnerDataSource}
        isMobile={this.state.isMobile}
      />,

      <Footer
        id="Footer"
        key="Footer"
        dataSource={FooterDataSource}
        isMobile={this.state.isMobile}
      />,
    ];
    return (
      <div
        className="templates-wrapper"
        ref={(d) => {
          this.dom = d;
        }}
      >
        {/* 如果不是 dva 2.0 替换成 {children} start */}
        {this.state.show && children}
        {/* 如果不是 dva 2.0 替换成 {children} end */}
      </div>
    );
  }
}
